var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0893 11.3333C16.4767 14.9166 18 16 18 16H6C6 16 8 14.578 8 9.59998C8 8.46865 8.42133 7.38331 9.17133 6.58331C9.92133 5.78331 10.94 5.33331 12 5.33331C12.2253 5.33331 12.4476 5.35331 12.6667 5.39331M13.1533 18C13.0361 18.202 12.8679 18.3697 12.6655 18.4863C12.4631 18.6029 12.2336 18.6643 12 18.6643C11.7664 18.6643 11.5369 18.6029 11.3345 18.4863C11.1321 18.3697 10.9639 18.202 10.8467 18M16.6667 9.33331C17.1971 9.33331 17.7058 9.1226 18.0809 8.74753C18.456 8.37245 18.6667 7.86375 18.6667 7.33331C18.6667 6.80288 18.456 6.29417 18.0809 5.9191C17.7058 5.54403 17.1971 5.33331 16.6667 5.33331C16.1362 5.33331 15.6275 5.54403 15.2525 5.9191C14.8774 6.29417 14.6667 6.80288 14.6667 7.33331C14.6667 7.86375 14.8774 8.37245 15.2525 8.74753C15.6275 9.1226 16.1362 9.33331 16.6667 9.33331Z",
    stroke: "#081E56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.b63dd5c8ae945dc2e041e5f9e2c2ae13.svg";
export { ForwardRef as ReactComponent };